<!--
 * @Author: xutao
 * @Date: 2023-03-07 12:05:37
 * @LastEditors: xutao
 * @LastEditTime: 2023-07-27 08:50:06
 * @FilePath: \homesite-web\src\components\productCard\index.vue
 * @Description:
 *
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved.
-->
<template>
  <div class="product_contain"
    :class="{ content_left: index % 3 == 0, content_mid: index % 3 == 1, content_right: index % 3 == 2 }">
    <div class="info_contain">
      <div class="info_contain_name">{{ item.name }}</div>
      <div class="info_contain_desc">{{ item.describe }}</div>
      <div class="info_contain_link" @click="clickCard">{{ item.link }}</div>
    </div>
    <img :src="item.url" alt width="100%" />
  </div>
</template>

<script>
export default {
  name: "product-card",
  props: {
    item: Object,
    index: Number
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    clickCard() {
      this.$router.push(this.item.router)
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 1440px) {
  .info_contain .info_contain_name {
    font-size: 30px;
  }

  .info_contain .info_contain_desc {
    font-size: 18px;
  }
}

.product_contain {
  width: calc(33.33% - 13.3px);
  height: 100%;
  margin-top: 20px;
}

.info_contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  width: 32%;
  margin: 50px 0;
  color: #ffffff;
}

.info_contain_name {
  font-family: HarmonyOS Sans SC;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  height: 44px;
  letter-spacing: 0px;
  /* color: rgba(0, 0, 0, 0.9); */
}

.info_contain_desc {
  font-size: 20px;
  font-weight: normal;
  line-height: 28px;
  text-align: center;
}

.info_contain_link {
  font-size: 16px;
  line-height: 24px;
  margin-top: 14px;
  color: #1472E2;
}

.info_contain_link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.content_left {
  background: linear-gradient(313deg, #D7D7D9 1%, #FFFFFF 100%);
}

.content_mid {
  background: linear-gradient(313deg, #D7D7D9 0%, #FFFFFF 100%)
}

.content_right {
  background: linear-gradient(313deg, #D7D7D9 -6%, #FFFFFF 100%);
}

.img_top {
  transform: scale(0.8) translateY(-80px);
}

.img_bottom {
  transform: translateY(40px);
}
</style>



// WEBPACK FOOTER //
// src/components/productCard/index.vue